import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = "/api2.0/canwebsitev3/";
const BookingDataContext = createContext();

const BookingDataProvider = ({ children }) => {
    const [availableTimes, setAvailableTimes] = useState([]);
    const [showAvailableTimes, setShowAvailableTimes] = useState(false);
    const [bookingsWithTimes, setBookingsWithTimes] = useState([]);
    const [isLoadingTime, setIsLoadingTime] = useState(false);
    const [isLoadingBooking, setIsLoadingBooking] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);

    const fetchAvailableTimes = async () => {
        setIsLoadingTime(true);
        try {
            const { data } = await axios.get(
                `${API_BASE_URL}/GetAvailableTimes`
            );
            setAvailableTimes(data.filter((time) => !time.IsBooked));
        } catch (error) {
            console.error("Failed to fetch available times:", error);
        } finally {
            setIsLoadingTime(false);
        }
    };

    const fetchBookingsWithAvailableTimes = async () => {
        setIsLoadingBooking(true);
        try {
            const { data } = await axios.get(
                `${API_BASE_URL}/GetBookingsWithAvailableTimes`
            );
            setBookingsWithTimes(data);
        } catch (error) {
            console.error(
                "Error fetching bookings with available times:",
                error
            );
        } finally {
            setIsLoadingBooking(false);
        }
    };

    const handleSaveAvailableTime = async (newTime) => {
        setIsLoadingTime(true);
        try {
            await axios.post(`${API_BASE_URL}/AddAvailableTime`, newTime);
            fetchAvailableTimes(); // Refresh the list of available times after adding
            // Optionally refresh bookings as the new time might be immediately booked
            // fetchBookingsWithAvailableTimes();
        } catch (error) {
            console.error("Failed to add available time:", error);
        } finally {
            setIsLoadingTime(false);
        }
    };

    const editBooking = async (bookingId, updatedBooking) => {
        setIsLoadingTime(true);
        try {
            const response = await axios.put(
                `${API_BASE_URL}/updatebooking/${bookingId}`,
                updatedBooking
            );
            if (response.status === 200) {
                fetchBookingsWithAvailableTimes(); // Refresh the list after editing
            } else {
                console.error("Failed to update booking:", response.data);
            }
        } catch (error) {
            console.error("Failed to update booking:", error);
        } finally {
            setIsLoadingTime(false);
        }
    };

    const deleteBooking = async (bookingId) => {
        try {
            await axios.delete(`${API_BASE_URL}/deletebooking/${bookingId}`);
            fetchAvailableTimes();
            fetchBookingsWithAvailableTimes(); // Refresh the list after deletion
        } catch (error) {
            console.error("Failed to delete booking:", error);
        }
    };

    return (
        <BookingDataContext.Provider
            value={{
                availableTimes,
                showAvailableTimes,
                setShowAvailableTimes,
                bookingsWithTimes,
                isLoadingTime,
                isLoadingBooking,
                isAddModalOpen,
                setIsAddModalOpen,
                fetchAvailableTimes,
                fetchBookingsWithAvailableTimes,
                handleSaveAvailableTime,
                editBooking,
                deleteBooking,
            }}
        >
            {children}
        </BookingDataContext.Provider>
    );
};
export { BookingDataContext, BookingDataProvider };
